'use client';

import _slicedToArray from "/codebuild/output/src2598/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
import { useIsomorphicEffect } from '../use-isomorphic-effect/use-isomorphic-effect.mjs';
import { randomId } from '../utils/random-id/random-id.mjs';
import { useReactId } from './use-react-id.mjs';
function useId(staticId) {
  var reactId = useReactId();
  var _useState = useState(reactId),
    _useState2 = _slicedToArray(_useState, 2),
    uuid = _useState2[0],
    setUuid = _useState2[1];
  useIsomorphicEffect(function () {
    setUuid(randomId());
  }, []);
  if (typeof staticId === "string") {
    return staticId;
  }
  if (typeof window === "undefined") {
    return reactId;
  }
  return uuid;
}
export { useId };